'use client';

import { Button } from '@/components/ui/button';
import Link from 'next/link';

export default function AudioError({
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <main className="flex min-h-[60vh] flex-col items-center justify-center px-6 py-24">
      <h1 className="text-3xl font-bold text-foreground mb-4">Page unavailable</h1>
      <p className="text-muted-foreground mb-8 text-center max-w-md">
        We couldn&apos;t load this page. Please try again shortly.
      </p>
      <div className="flex gap-4">
        <Button onClick={() => reset()} variant="outline" size="lg" className="rounded-full px-8">
          Try again
        </Button>
        <Button asChild size="lg" className="rounded-full px-8">
          <Link href="/audio">Back to Audio</Link>
        </Button>
      </div>
    </main>
  );
}
